"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = exports.createEventObject = exports.EventObjectImpl = void 0;
var functor_1 = require("./functor");
var helpers_1 = require("./helpers");
var EventObjectImpl = /** @class */ (function () {
    function EventObjectImpl() {
        this.isDefaultPrevented = false;
    }
    EventObjectImpl.prototype.preventDefault = function () {
        this.isDefaultPrevented = true;
    };
    return EventObjectImpl;
}());
exports.EventObjectImpl = EventObjectImpl;
function createEventObject(args) {
    var eventObject = new EventObjectImpl();
    for (var prop in args) {
        if (helpers_1.hasOwnProperty(args, prop)) {
            eventObject[prop] = args[prop];
        }
    }
    return eventObject;
}
exports.createEventObject = createEventObject;
var Event = /** @class */ (function () {
    function Event(subscriptionChanged) {
        if (subscriptionChanged) {
            this.subscriptionChanged = subscriptionChanged;
        }
    }
    Event.prototype.publish = function (thisObject, args) {
        if (!this.func) {
            // No subscribers
            return;
        }
        var eventObject = createEventObject(args);
        this.func.call(thisObject, eventObject);
        return eventObject;
    };
    Event.prototype.subscribe = function (handler) {
        if (!this.func) {
            Object.defineProperty(this, "func", { value: functor_1.Functor$create() });
        }
        this.func.add(handler);
        if (this.subscriptionChanged)
            this.subscriptionChanged(this);
    };
    Event.prototype.subscribeOne = function (handler) {
        if (!this.func) {
            Object.defineProperty(this, "func", { value: functor_1.Functor$create() });
        }
        this.func.add(handler, null, true);
        if (this.subscriptionChanged)
            this.subscriptionChanged(this);
    };
    Event.prototype.hasSubscribers = function (handler) {
        if (!this.func) {
            return false;
        }
        var functorItems = (this.func._funcs);
        return handler ? functorItems.some(function (i) { return i.fn === handler; }) : functorItems.length > 0;
    };
    Event.prototype.unsubscribe = function (handler) {
        if (!this.func) {
            // No subscribers
            return;
        }
        this.func.remove(handler);
        if (this.subscriptionChanged)
            this.subscriptionChanged(this);
    };
    Event.prototype.clear = function () {
        if (!this.func) {
            // No subscribers
            return;
        }
        this.func.clear();
        if (this.subscriptionChanged)
            this.subscriptionChanged(this);
    };
    return Event;
}());
exports.Event = Event;
